<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <!--
    Outer: chrome + min-h floor. Flex column so the inner scroll-row stretches
    to the bottom of the card, ensuring the horizontal scrollbar visually sits
    at the bottom edge of the card even when the table is shorter than 500px.

    Inner: overflow-x: auto for horizontal scrolling. We pair it with
    overflow-y: clip (NOT visible) because CSS coerces `visible` to `auto`
    when the other axis is `auto` — that coercion is exactly what produced the
    spurious vertical scrollbar. `clip` is the only value that escapes the
    coercion: x scrolls, y never shows a scrollbar, and since the inner box is
    >= the table's natural height, no content is actually clipped.
  -->
  <div data-slot="table-container" class="relative flex flex-col w-full bg-white border shadow-[0px_4px_10px_rgba(0,0,0,0.04)] min-h-[500px]">
    <div class="flex-1 overflow-x-auto" style="overflow-y: clip;">
      <table data-slot="table" :class="cn('min-w-full caption-bottom text-sm', props.class)" style="border-collapse: separate; border-spacing: 0;">
        <slot />
      </table>
    </div>
  </div>
</template>
